import { setFullDropZone } from '../../Store/layoutSlice';
import { Navigate, useParams } from 'react-router-dom';
import { useAppDispatch } from '../../Store/store';
import React, { useEffect } from 'react';
import { useAuthorize } from './useAuthorize';
import { setTaxNumber } from '../../Store/paramsBagSlice';
import { Spinner } from '../Layout/Spinner';

export const AuthenticateBankAccountsRoute = () => {
  const {token, taxNumber} = useParams();

  const dispatch = useAppDispatch();

  const { authorize, isLoading } = useAuthorize(token);

  useEffect(
    () => {
      dispatch(setTaxNumber(taxNumber));
      dispatch(setFullDropZone(true));

      (async () => {
        await authorize();
      })();
    }, // eslint-disable-next-line
    [
      dispatch,
    ]
  );

  if (isLoading) {
    return <Spinner />;
  }

  return <Navigate to={'/bankaccounts'} replace />;
};
